import * as React from 'react';
import {ProvidedGlobalProps, withGlobalProps} from '../../providers/globalPropsProvider';
import s from './ViewMore.scss';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {compose} from '../../../commons/utils';

export const ViewMoreDataHook = 'quick-view-more';

function ViewMoreComponent({t, globals: {navigate, product}}: ProvidedGlobalProps & IProvidedTranslationProps) {
  return (
    <a
      data-hook={ViewMoreDataHook}
      className={s.root}
      onClick={(e) => {
        e.preventDefault();
        navigate(product.urlPart, true);
      }}
      href={product.urlPart}>
      {t('productPage.quickView.viewProductDetails')}
    </a>
  );
}

export const ViewMore = compose(withTranslations('globals.texts'), withGlobalProps)(ViewMoreComponent);
